import React from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '../../../jo-components/ui/icon/icon';
import Message from '../../../jo-components/misc/message/message';
import ExpirationModal from "../../../jo-components/misc/timer/expirationModal";
import './style/timer.css';

function useInterval(callback, delay = null) {
    const cb = React.useRef(null);
    React.useEffect(() => {
        cb.current = callback;
    }, [callback]);

    React.useEffect(() => {
        if (!delay) {
            return;
        }

        const iid = setInterval(cb.current, delay);
        return () => {
            clearInterval(iid);
        };
    }, [delay]);
};

export const getSimpleRemainingTime = ( exp = null) => {
    const remainingTime = Math.floor(exp - (Date.now() / 1000));
    return exp ? remainingTime < 0 ? 0 : remainingTime : null;
};

export const getRemainingTime = ( exp = null , delay = () => {}, cb = () => {}) => {
    // compare in seconds
    let remain = getSimpleRemainingTime(exp);
    if (!remain) {
        delay(null)
        cb();
    }
    return remain;
};

export default function TimerComponent({expiration_time, onTimerReached=() => {}, className = '', minutesLabel = 'widget.resale.cart.minutes', secondsLabel = 'widget.resale.cart.seconds', config = {}}) {
    const { t } = useTranslation();
    const [delay, setDelay] = React.useState(1000);
    const [remainingTime, setRemainingTime] = React.useState(getSimpleRemainingTime(expiration_time));

    const cartTimer = React.useMemo(() => {
        return `${Math.floor(remainingTime / 60)} ${t(minutesLabel)} ${remainingTime % 60} ${t(secondsLabel)}`;
    }, [remainingTime, minutesLabel, secondsLabel]);

    useInterval(() => setRemainingTime(getRemainingTime((expiration_time), setDelay, onTimerReached)), delay);

    if (remainingTime === null) {
        return null;
    }

    return <div className='wz-timer-container'>
        <ExpirationModal
            open={remainingTime === 0}
            title={config.timer_settings.title_modal_expired_time}
            body={config.timer_settings.description_modal_expired_time}
            ctaLabel={config.timer_settings.cta_modal_expired_time}
        />
        <Message type='info'>
            <Icon name='timer' className="neo-timer-icon"/><strong>{t('widget.resale.cart.time-left')}</strong> {cartTimer}
        </Message>
    </div>
}